import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../public/locales/en/translation.json';
import translationTR from '../public/locales/tr/translation.json';
import translationDE from '../public/locales/de/translation.json';
import translationNL from '../public/locales/nl/translation.json';
import translationBG from '../public/locales/bg/translation.json';
import translationAR from '../public/locales/ar/translation.json';
var resources = {
    en: {
        translation: translationEN
    },
    tr: {
        translation: translationTR
    },
    de: {
        translation: translationDE
    },
    nl: {
        translation: translationNL
    },
    bg: {
        translation: translationBG
    },
    ar: {
        translation: translationAR
    }
};
var userLanguage = 'tr';
try {
    if (localStorage.getItem('system_language')) {
        userLanguage = localStorage.getItem('system_language');
    }
    else {
        userLanguage = window.Intl.NumberFormat().resolvedOptions().locale;
    }
}
catch (e) {
    userLanguage = 'tr';
}
i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
    resources: resources,
    fallbackLng: 'tr',
    debug: true,
    lng: userLanguage,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
});
export default i18n;
